<div class="lum-rfq-line-items-table">
  <div
    class="overlay"
    lumAppLoader
    [loading]="loading"
    [classes]="'loading blur'"
  ></div>
  <form [formGroup]="form">
    <div class="table-wrapper">
      <table class="lum-table lum-table--classic striped">
        <thead>
          <tr class="table__head-row">
            <th class="w-5">
              <mat-checkbox class="lum-checkbox" (change)="onSelectAllSkus($event)">
              </mat-checkbox>
            </th>
            <th><b>Image</b></th>
            <th><b>SKU</b></th>
            <th class="w-70"><b>Product Name</b></th>
            <th><b>Available Stocks</b></th>
            <th><b>Status</b></th>
            <th><b>Category</b></th>
            <th><b>Subcategory</b></th>
            <th><b>Tags</b></th>
            <!-- quantity -->
            <th class="w-40">
              <ng-container *ngIf="enableBulkQtyUpdate; else buttonEnable">
                <input
                  formControlName="defaultQuantity"
                  type="number"
                  inputmode="numeric"
                  class="lum-input w-26"
                  [min]="1"
                  matInput
                  lumDecimalLimit
                  (input)="onSetBulkQty($event)"
                />
              </ng-container>
              <ng-template #buttonEnable>
                <button
                  class="lum-button"
                  (click)="enableBulkQtyUpdate = !enableBulkQtyUpdate"
                >
                  Bulk Update Qty
                </button>
              </ng-template>
            </th>
            <!-- add all -->
            <th></th>
          </tr>
        </thead>
        <tbody formArrayName="rfqs">
          <ng-container
            *ngFor="
              let item of lineItemsFormArray.controls;
              trackBy: trackByControlValue;
              let i = index
            "
          >
            <tr [formGroupName]="i" (click)="onSelectRfq(item)">
              <td (click)="$event.stopPropagation()">
                <mat-checkbox
                  class="lum-checkbox"
                  [checked]="item.value?.selected"
                  (change)="onSelectRfq(item)"
                >
                </mat-checkbox>
              </td>
              <td>
                <div class="flex align-items-center">
                  <img
                    [lumRfqThumbnailUrl]="item.value"
                    alt=""
                    class="lum-img lum-thumbnail"
                  />
                </div>
              </td>
              <td>
                <div class="table__product-sku">
                  {{ item.value?.sku }}
                </div>
              </td>
              <td>
                <div
                  [matTooltip]="item.value?.product_name"
                  class="table__product-name"
                >
                  {{ item.value?.product_name }}
                </div>
              </td>
              <td>
                {{
                  item.value?.location_stock?.qty_onhand -
                    item.value?.location_stock?.qty_pending | number
                }}
              </td>
              <td>
                <lum-invoice-skus-status
                  [item]="item.value"
                ></lum-invoice-skus-status>
              </td>
              <td>{{ item.value?.category?.product_category }}</td>
              <td>{{ item.value?.subcategory?.sub_category }}</td>
              <td>
                <div class="invoice-sku-tags__wrapper flex">
                  <ng-container
                    *ngFor="
                      let tag of item.value?.formattedTags;
                      trackBy: trackById
                    "
                  >
                    <mat-chip
                      class="
                        lum-chip lum-chip--label lum-chip--x-small border-transparent font-bold text-cloud-900 bg-cloud-300 mx-1 text-ellipsis
                      "
                      >{{ tag }}</mat-chip
                    >
                  </ng-container>
                </div>
              </td>
              <td (click)="$event.stopPropagation()">
                <input
                  formControlName="quantity"
                  type="number"
                  inputmode="numeric"
                  class="lum-input w-26"
                  [min]="1"
                  matInput
                  lumDecimalLimit
                />
              </td>
              <td (click)="$event.stopPropagation()">
                <div
                  class="rfq-action-item__wrapper"
                  [ngClass]="{ show: item.value?.selected }"
                >
                  <button
                    type="button"
                    class="lum-button"
                    [ngClass]="
                      item.value?.selected
                        ? 'lum-button--primary'
                        : 'lum-button--secondary'
                    "
                    (click)="onSelectRfq(item)"
                  >
                    {{ item.value?.selected ? 'Added' : 'Add' }}
                  </button>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </form>
</div>
